<template>
  <div :class="['main', 'mainIndicateur2', 'mainIndicateur34', defileCi == 4 ? 'mainFifi' : '']">
      <div class="ind3-section ind-sectionSpe">
        <h2 :class="['h2Ind2', defileCi == 1 ? 'vueActiveI' : 'vueNoneI']">Questions Complémentaires</h2>
        <div :class="['ind2-bloc2', 'vueActiveI2', defileCi == 1 ? 'vueActiveI1' : 'vueNoneI']">
          <div class="bloc-douleur3">
            <h4>Combien d'arrêts maladie vos douleurs ont-elles engendré ?</h4>
            <ul class="douleur3 douleur33">
              <li>
                <button  :class="[{selected: douleur.arret === 0}]" @click.prevent="douleur.arret = 0, sauvegardePlus()">
                  <p>Aucun Arrêt</p>
                </button>
              </li>
              <li>
                <button :class="[{selected: douleur.arret === 1}]" @click.prevent="douleur.arret = 1, sauvegardePlus()">
                  <p>1 Arrêt</p>
                </button>
              </li>
              <li>
                <button  :class="[{selected: douleur.arret === 2}]" @click.prevent="douleur.arret = 2, sauvegardePlus()">
                  <p>2 Arrêts</p>
                </button>
              </li>
              <li>
                <button :class="[{selected: douleur.arret === 3}]" @click.prevent="douleur.arret = 3, sauvegardePlus()">
                  <p>3 Arrêts</p>
                </button>
              </li>
              <li>
                <button :class="[{selected: douleur.arret === 4}]" @click.prevent="douleur.arret = 4, sauvegardePlus()">
                  <p>Plus de 3 Arrêts</p>
                </button>
              </li>
            </ul>
          </div>
          <!--<div class="gestionnaireBouton">
            <button  @click.prevent="sauvegardePlus()"  class="boutonInfo"><i  class="fa fa-angle-right"></i></button>
          </div>-->
        </div>

          <div :class="['ind2-bloc2', defileCi == 2 ? 'vueActiveI1' : 'vueNoneI']">
          <div class="bloc-douleur3">
            <h4>Quels est le total annuel cumulé de vos arrêt maladie lié à vos douleurs ?</h4>
            <ul class="douleur3">
              <li>
                <button  :class="[{selected: douleur.arretTotal === 0}]" @click.prevent="douleur.arretTotal = 0, sauvegardePlus()">
                  <p>Moins de 3 Jours</p>
                </button>
              </li>
              <li>
                <button :class="[{selected: douleur.arretTotal === 1}]" @click.prevent="douleur.arretTotal = 1, sauvegardePlus()">
                  <p>De 3 à 7 Jours</p>
                </button>
              </li>
              <li>
                <button  :class="[{selected: douleur.arretTotal === 2}]" @click.prevent="douleur.arretTotal = 2, sauvegardePlus()">
                  <p>De 7 à 30 Jours</p>
                </button>
              </li>
              <li>
                <button :class="[{selected: douleur.arretTotal === 3}]" @click.prevent="douleur.arretTotal = 3, sauvegardePlus()">
                  <p>Plus de 30 Jours</p>
                </button>
              </li>
            </ul>
          </div>
          <!--<div class="gestionnaireBouton">
            <button   @click.prevent="sauvegardeMoins()"  class="boutonInfo"><i  class="fa fa-angle-left" ></i></button>
            <button  @click.prevent="sauvegardePlus()"  class="boutonInfo"><i  class="fa fa-angle-right"></i></button>
          </div>-->
        </div>
    <div :class="['ind2-bloc3', 'bloc3Spe', defileCi == 3 ? 'vueActiveI1' : 'vueNoneI']">
          <div class="bloc-douleur4 bld4bis" >
            <h4>Ces plaintes ont-elles fait l'objet d'une prise en charge (plusieurs réponses possibles):</h4>
            <ul class="douleur4">
              <li>
                <button  :class="[{selected: douleur.pec.chir === true}]" @click.prevent="inversedBool('chir')">
                  <p>Chirurgicale</p>
                </button>
              </li>
              <li>
                <button :class="[{selected: douleur.pec.med === true}]" @click.prevent="inversedBool('med')">
                  <p>Médicale</p>
                </button>
              </li>
              <li>
                <button  :class="[{selected: douleur.pec.para === true}]" @click.prevent="inversedBool('para')">
                  <p>Paramédicale</p>
                </button>
              </li>
              <li>
                <button :class="[{selected: douleur.pec.aucun === true}]" @click.prevent="inversedBool('aucun')">
                  <p>Aucune</p>
                </button>
              </li>
            </ul>
          </div>
          <!--<div class="gestionnaireBouton">
            <button   @click.prevent="sauvegardeMoins()"  class="boutonInfo"><i  class="fa fa-angle-left" ></i></button>
            <button  @click.prevent="defileCi++"  class="boutonInfo"><i  class="fa fa-angle-right"></i></button>
          </div>-->
        </div>          
        <div :class="[defileCi == 4 ? 'vueActiveI1' : 'vueNoneI', 'vueActive14']">
              <h4 class="h4CiFinale">Ces plaintes ont elles engendré un changement professionnel (plusieurs réponses possibles):</h4>
              <ul class="ind4Ul">
                  <li v-for="tab in info" :id='tab.position' v-on:click="actived(tab.position)" :key="tab.title" v-bind:class="[ activetab[tab.position] == true ? 'actived' : '', 'ind4Li' ]">{{tab.title}}</li>
              </ul>
        </div>
        <div class="gestionnaireFakeBouton gFK2" >
            <button  @click.prevent="sauvegardePlus()"  :class="/*[defileCi == 3 ? 'vueActiveI' : 'vueNoneI',*/[ 'boutonFakeValider']" v-if="defileCi == 3">Valider</button>
      </div>
    </div>
    
  </div>
  
</template>

<script>
import Autocomplete from 'vuejs-auto-complete'
export default {
  name: "Indicateur_4",
  data() {
    return {
        info: [{ title: "Aucun changement" , position: 6},
                { title: "Un aménagement de votre poste de travail" , position: 5},
                { title: "Un changement de poste de travail" , position: 4}, 
                { title: "Une reconversion professionnelle" , position: 3},
                { title: "Une inaptitude" , position: 2},
                { title: "Une invalidité" , position: 1}],
        user: JSON.parse(localStorage.user)|| [],
        activetab: {1: false, 2: false, 3: false, 4: false, 5: false, 6: false},
        result: '',
          douleur: {
        arret: null,
        arretTotal: null,
        pec: {chir : false, med : false, para : false, aucun : false},
      },
      tableau_profession: [{
        id:1,
        name:'soudeur'
        },{
          id:2,name:'chaudronier'
      }],
      defileCi: 1,
    };
  },
  components: {
    Autocomplete,
  },
  created(){

    if (typeof(localStorage.user) !== undefined){
      this.user = JSON.parse(localStorage.user);
      this.indicateur = this.user.cI;
      let valider = document.getElementsByClassName('submitQuestionnaire');
      
      Object.keys(valider).forEach(function (element, index) {
          valider[element].style.visibility = 'hidden';
        }); 
      
      /*
      if (this.indicateur !== null){
      this.indicateur = this.indicateur[4];
      //console.log(this.indicateur);
      for (let i = 0;i < Object.size(this.indicateur.resultat); i++) {
        if (i == 0){
          if(this.indicateur.resultat[0] == "Plus de 3 Arrêts"){
            this.douleur.arret = 4;
          }else if(this.indicateur.resultat[0] == "3 Arrêt"){
            this.douleur.arret = 3;
          }else if(this.indicateur.resultat[0] == "2 Arrêts"){
            this.douleur.arret = 2;
          }else if(this.indicateur.resultat[0] == "1 Arrêt"){
            this.douleur.arret = 1;
          }else{
            this.douleur.arret = 0;
          } 
        }
        if (i == 1){
          if(this.indicateur.resultat[1] == "Plus de 30 Jours"){
            this.douleur.arretTotal = 3;
          }else if(this.indicateur.resultat[1] == "De 7 à 30 Jours"){
            this.douleur.arretTotal = 2;
          }else if(this.indicateur.resultat[1] == "De 3 à 7 Jours"){
            this.douleur.arretTotal = 1;
          }else{
            this.douleur.arretTotal = 0;
          } 
        }
        if (i == 2){
          if(this.indicateur.resultat[2] == "Chirurgicale" || this.indicateur.resultat[3] == "Chirurgicale" || this.indicateur.resultat[4] == "Chirurgicale"){
            this.douleur.pec.chir = true;
          }
          if(this.indicateur.resultat[2] == "Médicale" || this.indicateur.resultat[3] == "Médicale"  || this.indicateur.resultat[4] == "Médicale" ){
            this.douleur.pec.med = true;
          }
          if(this.indicateur.resultat[2] == "Paramédicale" || this.indicateur.resultat[3] == "Paramédicale"  || this.indicateur.resultat[4] == "Paramédicale" ){
            this.douleur.pec.para = true;
          }
          if(this.indicateur.resultat[2] == "Aucune"){
            this.douleur.pec.aucun = true;
          }
        }
      //console.log(this.indicateur.resultat);
      }
      }
      this.indicateur1 = this.indicateur[3];
      //console.log(this.indicateur);
      this.indicateur1.resultat.forEach(element => {
        this.info.forEach(element1 => {
          if (element1.title == element){
            this.activetab[element1.position] = true;
          }
        });
      });*/
    }
  },
  methods: {
    sexDefine (sexe){
      if (sexe === 0) {
        this.user.sexe = 'femme'
        //console.log(this.user.sexe)
        
      }else{
        this.user.sexe = 'homme'
        //console.log(this.user.sexe)
        //console.log(this.user.profession)       
      }
    },
    ageDefine (age){
      if (age === 'A'){
        this.user.age = '-19'
        //console.log(this.user.age + ' ans')
      }else if (age === 'B'){
        this.user.age = '20-30'
        console.log(this.user.age + ' ans')
      }else if (age === 'C'){
        this.user.age = '30-40'
        console.log(this.user.age + ' ans')
      }else if (age === 'D'){
        this.user.age = '40-50'
        //console.log(this.user.age + ' ans')
      }else{
        this.user.age = '+60'
        //console.log(this.user.age + ' ans')
      }
    },
    addMesure (att){
      if (att === 'poids'){
        this.user.poids++
        //console.log(this.user.poids + ' kg')
      }else if (att === 'taille'){
        this.user.taille++
        //console.log(this.user.taille + ' cm')
      }
    },
    lessMesure (att){
      if (att === 'poids'){
        this.user.poids--
        //console.log(this.user.poids + ' kg')
      }else if (att === 'taille'){
        this.user.taille--
        //console.log(this.user.taille + ' cm')
      }     
    },
    inversedBool (dd){
      if (dd === 'chir' && this.douleur.pec.aucun == false){
        this.douleur.pec.chir = !this.douleur.pec.chir;
      }else if (dd == 'para' && this.douleur.pec.aucun == false){
        this.douleur.pec.para = !this.douleur.pec.para;
      }else if (dd == 'med' && this.douleur.pec.aucun == false){
        this.douleur.pec.med = !this.douleur.pec.med;
      }else if (dd == 'aucun'){
        this.douleur.pec.aucun = !this.douleur.pec.aucun;
        if (this.douleur.pec.aucun == true){
          alert('Attention si vous voulez choisir une autre réponse désélectionné "aucun"');
          this.douleur.pec.med = false;
          this.douleur.pec.chir = false;
          this.douleur.pec.para = false;
        }
      }
    },
    sauvegardePlus(){
       var corps = document.getElementsByClassName('selected');
      
        if (this.defileCi == 1){
          var array = [];
        }else{
          var array = JSON.parse(localStorage.indicateur4);
        }
        if (this.defileCi == 1){
          array.push({'nbArret':this.douleur.arret});
        }else if (this.defileCi == 2){
          array.push({'dureeArret':this.douleur.arretTotal});
        }else if (this.defileCi == 3){
          array.push({'pec':this.douleur.pec}); 
                let valider = document.getElementsByClassName('submitQuestionnaire');
      
      Object.keys(valider).forEach(function (element, index) {
          valider[element].style.visibility = 'visible';
        }); 
        }else if (this.defileCi == 4){
 
        }
      localStorage.indicateur4 = JSON.stringify(array);
      console.log(localStorage.indicateur4)
      this.defileCi++;
      if (this.defileCi === 4){
        this.$emit('goValider');
      }
    },
    actived (nb){
      if (this.activetab[6] == false){
        this.activetab[nb] = !this.activetab[nb];
        if (nb == 6){
          alert('Attention si vous voulez choisir une autre réponse, désélectionner "aucun"');
          for (let i = 1; i < 6; i++) {
          this.activetab[i] = false;
          }
        }
      }else if (nb == 6 && this.activetab[6] == true){
          this.activetab[nb] = !this.activetab[nb]; 
        }
  },
  },
  computed: {
    ideal (){
      return this.user.poids = this.user.taille -100 - ((this.user.taille - 150)/4);
    }
  }
};
</script>

<style>
.ind-sectionSpe{
  position: relative;
}
.vueActiveI1 {
  position: relative !important;
  top: 20px !important;
  visibility: visible;
  opacity: 1 !important;
  transform: translateX(0px) !important;
  transition: visibility 2s, opacity 0.8s, transform 1.5s linear !important;
}
.vueActiveI2 {
  top: 40px !important;
}
.vueNoneI {
  position: absolute !important;
  top: 20px !important;
  visibility: hidden;
  opacity: 0 !important;
  transform: translateX(+30px) !important;
  transition: visibility 2s, opacity 0.8s, transform 1.5s linear !important;
}
.indtab .main {
  overflow: visible;
}
.boutonFakeValider{
  position: realtive !important;
  margin-left: auto;
  margin-right: auto;
  margin-top: 20px;;
  width: 90%;
  min-height: 35px;
  border-radius: 25px;
  border: none;
  background-color: #c41316;
  color: #fff;
  cursor: pointer;
  outline: none;
}
.boutonFakeValider:hover {
  border: 2px solid #ccc;
}
.bloc3Spe{
  width: 100%;
  height: 60%;
}
.gestionnaireFakeBouton{
  height: 40%;
  width: 100%;
  position: relative;
  top: 25%;
}
.bloc-douleur3, .bloc-douleur4{
  height: 50vh;
  width: 90%;
}
.ind4Ul{
  height: 40vh;
}
.vueActive14{
  top: 0px !important;
}
.h4CiFinale{
  padding-left: 5%;
}
.mainFifi{
  height: 65vh;
}
</style>


// WEBPACK FOOTER //
// src/components/indicateur/Indicateur_4.vue